import {
  AppBar,
  Box,
  Container,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import { ENV } from "../../utils/getEnv";
import MainMenu from "../MainMenu";

const styles = {
  brand: {
    display: "none",
  },
  title: {
    marginLeft: "auto",
  },
  main: {
    paddingTop: "66px",
  },
};

const Mobile = ({ title = null, children }) => {
  return (
    <>
      <AppBar sx={styles.appBar} className="no-print">
        <Toolbar sx={styles.toolbar}>
          <IconButton href="/" sx={styles.homeButton}>
            <img src="/favicon192.png" alt="Home" width={24} />
          </IconButton>
          <Typography variant="h6" noWrap sx={styles.brand}>
            <Link to="/">{ENV.NAME}</Link>
          </Typography>
          <Typography variant="h6" sx={styles.title}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Container>
        <Box sx={styles.main}>{children}</Box>
        <MainMenu mobile />
      </Container>
    </>
  );
};

export default Mobile;
